export type TeamView = 'month' | 'week';
export const localDate = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export function teamDays(anchor: string, view: TeamView) {
  const first = new Date(anchor + 'T12:00:00');
  if (view === 'month') first.setDate(1);
  first.setDate(first.getDate() - ((first.getDay() + 6) % 7));
  return Array.from({ length: view === 'month' ? 42 : 7 }, (_, i) => {
    const d = new Date(first);
    d.setDate(first.getDate() + i);
    return d;
  });
}
export function teamRange(days: Date[]) {
  const from = new Date(days[0]),
    to = new Date(days.at(-1)!);
  from.setHours(0, 0, 0, 0);
  to.setDate(to.getDate() + 1);
  to.setHours(0, 0, 0, 0);
  return { from: from.toISOString(), to: to.toISOString() };
}
export function moveTeamDate(anchor: string, view: TeamView, step: number) {
  const d = new Date(anchor + 'T12:00:00');
  if (view === 'month') {
    d.setDate(1);
    d.setMonth(d.getMonth() + step);
  } else d.setDate(d.getDate() + step * 7);
  return localDate(d);
}
export function overlapsDay(start: string, end: string, day: Date) {
  const from = new Date(day),
    to = new Date(day);
  from.setHours(0, 0, 0, 0);
  to.setDate(to.getDate() + 1);
  to.setHours(0, 0, 0, 0);
  return Date.parse(start) < to.getTime() && Date.parse(end) > from.getTime();
}
export function commonSlots(
  from: string,
  to: string,
  durationMinutes: number,
  busy: { start: string; end: string }[],
) {
  const slots: { start: string; end: string }[] = [];
  for (
    let start = Date.parse(from);
    start + durationMinutes * 60000 <= Date.parse(to);
    start += 30 * 60000
  ) {
    const end = start + durationMinutes * 60000;
    if (!busy.some((b) => Date.parse(b.start) < end && Date.parse(b.end) > start))
      slots.push({ start: new Date(start).toISOString(), end: new Date(end).toISOString() });
  }
  return slots;
}
